export default __webpack_public_path__ + "static/media/setting_icon.ea1865da.svg";